import React from 'react';
import { Marker, Tooltip, useMapEvents } from 'react-leaflet';
import L, { PointTuple } from 'leaflet';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'helpers/hooks';

import { FilterRadius } from '../FilterRadius';
import { Pin } from '../interfaces';
import { AppState } from '../../../store/interfaces';
import { setNewPin } from '../../../store/map/actions';

const tooltipOffset: PointTuple = [0, -20];

const icon = L.icon({
  iconUrl: '/assets/map/pin_selected.svg',
  iconSize: [30, 45],
});

export const NewPin: React.FC = React.memo(function () {
  const dispatch = useDispatch();
  const newPin = useSelector((app: AppState) => app.map.newPin, shallowEqual);
  const { t } = useTranslation();

  useMapEvents({
    click(e) {
      const pin = {
        address: '',
        position: e.latlng,
      } as Pin;

      dispatch(setNewPin(pin));
    },
  });

  if (!newPin) {
    return null;
  }

  return (
    <>
      <FilterRadius lat={newPin.position.lat} lng={newPin.position.lng} />
      <Marker zIndexOffset={4000} icon={icon} position={newPin.position}>
        <Tooltip direction="top" opacity={1} permanent offset={tooltipOffset}>
          {t('map.pins.newPin')}
        </Tooltip>
      </Marker>
    </>
  );
});
